import { ColumnDef } from '@tanstack/react-table';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'configs';
import {
  TransactionStatusColor,
  TransactionStatusEnum,
} from 'configs/constants';
import { format } from 'date-fns';
import { Button, Icon, IUseFormStructureItem, NumberUtils } from 'modules';
import React from 'react';
import { MainRouteKeys } from 'routes/enums';
import { BillPayTransactionEntity } from 'services/openapi';

export type FilterType = {
  orderCode?: string;
  refreshData: number;
  pageSize: number;
  pageIndex: number;
};

export const getInitFilterValues = (urlParams: any): FilterType => {
  return {
    orderCode: urlParams?.get('orderCode') ?? '',
    refreshData: 0,
    pageSize: Number(urlParams?.get('pageSize') ?? DEFAULT_PAGE_SIZE),
    pageIndex: Number(urlParams?.get('pageIndex') ?? DEFAULT_PAGE_INDEX),
  };
};

// export const initFilterValues: FilterType = {
//   orderCode: '',
//   refreshData: 0,
// };

export function filterOptions(data: any): IUseFormStructureItem[] {
  return [
    {
      name: 'orderCode',
      label: 'Mã đơn hàng',
      defaultValue: data?.orderCode,
      isReadOnly: true,
    },
    {
      name: 'txSum',
      label: 'Lượng giao dịch',
      defaultValue: data?.txSum,
      isReadOnly: true,
    },
    {
      name: 'txSuccessSum',
      label: 'Lượng thành công',
      defaultValue: data?.txSuccessSum,
      isReadOnly: true,
    },
    {
      name: 'txFailedSum',
      label: 'Lượng thất bại',
      defaultValue: data?.txFailedSum,
      isReadOnly: true,
    },
    {
      name: 'orderStatus',
      label: 'Trạng thái',
      defaultValue: data?.orderStatus,
      isReadOnly: true,
    },
  ];
}

export const columnsDefined = (
  onClickCallback: Function,
): ColumnDef<BillPayTransactionEntity, unknown>[] => {
  return [
    {
      accessorKey: 'transactionCode',
      header: 'Mã giao dịch',
      cell: (info) => {
        return (
          <a href={`${MainRouteKeys.TransactionBills}/${info.getValue()}`}>
            {String(info.getValue())}
          </a>
        );
      },
    },
    {
      accessorKey: 'execPhoneNumber',
      header: 'Tài khoản thực hiện',
    },
    {
      accessorKey: 'leaderPhoneNumber',
      header: 'Trưởng nhóm',
    },
    {
      accessorKey: 'serviceType',
      header: 'Loại dịch vụ',
    },
    {
      id: 'customerCode',
      header: 'Mã khách hàng',
      cell: (info) => info.row.original.customerBill.customerCode,
    },
    {
      id: 'customerFullName',
      header: 'Tên khách hàng',
      cell: (info) => info.row.original.customerBill.customerName,
    },
    {
      id: 'period',
      header: 'Kỳ tháng',
      cell: (info) => {
        const period = info.row.original.customerBill.billPeriod;
        const month = String(period)?.slice?.(4, 6) || '';
        const year = String(period)?.slice?.(0, 4) || '';
        return `${month}/${year}`;
      },
    },
    {
      id: 'amount',
      header: 'Số tiền',
      // cell: (info) => NumberUtils.toFormatNumber(Number(info.getValue())),
      cell: (info) => {
        return (
          <div className={'textInfo'}>
            {NumberUtils.toFormatNumber(
              info.row.original?.customerBill?.billAmount ?? 0,
            )}
          </div>
        );
      },
      // cell: (info) => NumberUtils.toFormatNumber(info.row.original.customerBill.billAmount),
    },
    {
      accessorKey: 'paymentAmount',
      header: 'Thanh toán',
      // cell: (info) => NumberUtils.toFormatNumber(Number(info.getValue())),
      cell: (info) => {
        return (
          <div className={'textInfo'}>
            {info.getValue()
              ? NumberUtils.toFormatNumber(Number(info.getValue()))
              : '0'}
          </div>
        );
      },
    },
    {
      accessorKey: 'rollbackAmount',
      header: 'Hoàn trả',
      // cell: (info) => NumberUtils.toFormatNumber(Number(info.getValue())),
      cell: (info) => {
        return (
          <div className={'textInfo'}>
            {info.getValue()
              ? NumberUtils.toFormatNumber(Number(info.getValue()))
              : '0'}
          </div>
        );
      },
    },
    {
      accessorKey: 'status',
      header: 'Trạng thái',
      cell: (info) => (
        <div
          className={
            TransactionStatusColor[
              info.getValue() as keyof typeof TransactionStatusColor
            ]
          }
        >
          {String(info.getValue())}
        </div>
      ),
    },
    {
      accessorKey: 'updatedAt',
      header: 'Thời gian',
      cell: (info) =>
        format(new Date(String(info.getValue())), 'HH:mm:ss dd/MM/yyyy'),
    },
    {
      id: 'action',
      header: 'Thao tác',
      cell: (info) => {
        const now = new Date();

        const fifteenMinutesAgo = new Date(now.getTime() - 15 * 60 * 1000);

        const someTime = new Date(info?.row?.original?.updatedAt);

        return (
          <div className='d-flex justify-content-center'>
            <Button
              type='button'
              buttonType='success'
              className='mr0 pdr10 pdl10 pdt0 pdb0'
              label={
                <a
                  href={`${MainRouteKeys.TransactionBills}/${info.row.original?.transactionCode}`}
                >
                  <Icon.Eye />
                </a>
              }
            />
            {someTime > fifteenMinutesAgo &&
              info.row.original?.status ==
                TransactionStatusEnum['Thành công'] && (
                <Button
                  onClick={() =>
                    onClickCallback(info.row.original?.transactionCode)
                  }
                  label='Gửi yêu cầu hủy'
                  type='button'
                  buttonType='danger-outline'
                  className='mr0 ml10 pd5 textNoWrap'
                />
              )}
          </div>
        );
      },
    },
  ];
};
